// extracted by mini-css-extract-plugin
module.exports = {"selectionButtonFullWidth":"_3YE-Z","textInputErrorBorderColor":"_2lhsE","minimumAmountErrorColor":"_1XMfd"};